export class Installation{
    constructor(
        public installationId: string | null,
        public installationReference: string | null,
        public installationMacAddress: string | null = null,
    ){}
}